module.exports = __webpack_public_path__ + "static/media/team-jnain.dc04a07c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team-jnain.jpg
// module id = 290
// module chunks = 0